import { Layout, Row, Typography } from "antd";
import { useTranslation } from "react-i18next";
import ArrowLeftIconComponent from "../../../components/ArrowLeftIconComponent";
import { APP_DOMAIN } from "../../../utls/constants";
import "./index.less";

const GeneralCondtionOfUse = () => {
  const { t } = useTranslation();
  return (
    <Layout className="background-black">
      <Layout.Content className="content GeneralConditionContentWrapper background-transparent">
        <Row className="relative justify-content-center header-title-container-70">
          <ArrowLeftIconComponent left={-15} top={10} />
          <Typography.Text className="ml-20 mt-10 header-title-black-22">{t("general-conditions-of-use")}</Typography.Text>
        </Row>
        <Row className="GeneralConditionContext">
          <Typography.Paragraph>
            <strong>v12.06.2024 made for ITDW by Versius.</strong>
          </Typography.Paragraph>
          <Typography.Paragraph>
            Welcome to Twizz, the platform that allows content creators to live from their passion (hereinafter “the Operator” or “Twizz”). Twizz was
            created and is operated by ITDW, a limited liability company whose registered office is 105 rue Jean-Joseph Piret, 6280, Gerpinnes
            Belgium. To contact us, you can email contact@${APP_DOMAIN} and call at +32474505038.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Twizz allows you to: – Reference the Media and Creator Profiles; – Connect Creators and Users in order to share Media free of charge or
            for a fee; – Allow Ambassadors to sponsor Creators or other Ambassadors.
          </Typography.Paragraph>
          <Typography.Paragraph>
            By using the Platform, Users can subscribe to a Subscription with the Creators of their choice to access exclusive Media, offered by
            Creators.
          </Typography.Paragraph>
          <Typography.Paragraph>
            In this context, it is recalled that Twizz intervenes as an online platform operator. Its role is limited to the hosting and referencing
            of Media as well as the linking of Creators and Users, for the sharing and promotion of Media.
          </Typography.Paragraph>
          <Typography.Paragraph>
            These General Terms and Conditions of Use (GCU) govern the use by any User of the Platform and the associated Services and
            functionalities.
          </Typography.Paragraph>
          <Typography.Paragraph>
            ANY USE MADE IN ANY CAPACITY OF THE PLATFORM NECESSARILY IMPLIES THE UNRESERVED ACCEPTANCE, BY THE USER, OF THESE GENERAL CONDITIONS OF
            USE (GCU).
          </Typography.Paragraph>
          <Typography.Paragraph>Article 1. Definitions</Typography.Paragraph>
          <Typography.Paragraph>
            The terms, mentioned below, have in these General Terms and Conditions of Use, the following meaning:
          </Typography.Paragraph>
          <Typography.Paragraph>
            ● “Subscription”: means the right to access its Media granted by the Creator to the User in return for the price of the Subscription;
          </Typography.Paragraph>
          <Typography.Paragraph>● “Subscribe”: means the User who has subscribed to a Subscription with a Creator;</Typography.Paragraph>
          <Typography.Paragraph>
            ● “Ambassador”: means any User who sponsors a Creator or other Ambassador by means of a sponsorship link, according to the terms defined
            in the General Terms and Conditions of Sponsorship;
          </Typography.Paragraph>
          <Typography.Paragraph>
            ● ” Bookmark”: refers to a bookmark or bookmark placed on content so that it can be more easily found in the corresponding section of the
            User’s Account.
          </Typography.Paragraph>
          <Typography.Paragraph>
            ● “Chat”: refers to the public and instant messaging on which Users can post messages during a Live;
          </Typography.Paragraph>
          <Typography.Paragraph>
            ● “Order”: means any Subscription, Private Media, Push Media and/or Ticket order placed by a User with the Creator on the Platform;
          </Typography.Paragraph>
          <Typography.Paragraph>
            ● “Commission”: refers to the percentage of the Creator’s earnings paid to Twizz in return for its Services. The Commission corresponds to
            a percentage of the Price of any Order made from the Creator;
          </Typography.Paragraph>
          <Typography.Paragraph>
            ● “Account”: refers to the computer interface hosted on the Platform and allowing the User to use the Platform and the Services, while
            benefiting from a space hosting his data;
          </Typography.Paragraph>
          <Typography.Paragraph>
            ● “General Conditions of Sale”: means the contractual conditions of the Platform governing the subscription to a Subscription and the sale
            of Private Media, Push Media and/or Live Access Tickets;
          </Typography.Paragraph>
          <Typography.Paragraph>
            ● “General Conditions of Sponsorship”: means the contractual conditions detailing the terms under which Users can sponsor other Users;
          </Typography.Paragraph>
          <Typography.Paragraph>
            ● “General Conditions of Service” or “CGS”: refers to the General Conditions of Service and all their Annexes, which govern the provision
            of the Services by Twizz to the Creators;
          </Typography.Paragraph>
          <Typography.Paragraph>
            ● “General Conditions of Use” or “GCU” or “Contract”: means these contractual conditions made available on the Platform, in order to
            regulate the use of it by any User;
          </Typography.Paragraph>
          <Typography.Paragraph>
            ● “Content”: means any element published by a User on the Platform, whether it is a Media published by a Creator, or a message or content
            of any kind (text, image, video, sound, multimedia) published by a User;
          </Typography.Paragraph>
          <Typography.Paragraph>
            ●”Creator”: means any natural or legal person registered on the Platform as a creator, sharing the Media through it and who has subscribed
            to the General Terms and Conditions of Services;
          </Typography.Paragraph>
          <Typography.Paragraph>
            ● “News Feed” or “Feed”: means, on the home page, the User’s news feed available on the Platform;
          </Typography.Paragraph>
          <Typography.Paragraph>
            ● “Bank Fees”: means the fees deducted from the sums paid by the User in return for the Payment Services provided to the Creator. Bank
            Fees are equivalent to a percentage of the amounts processed by Payment Services. They are therefore calculated on the amounts actually
            paid, including all taxes, including VAT and all possible costs;
          </Typography.Paragraph>
          <Typography.Paragraph>
            ● “Identifiers”: means the User’s email address and password chosen by him, necessary to access his Account on the Platform;
          </Typography.Paragraph>
          <Typography.Paragraph>
            ● “KYC”: refers to the “Know Your Customer” procedure consisting of requiring a User to prove his identity and eligibility for certain
            Services offered by Twizz.
          </Typography.Paragraph>
          <Typography.Paragraph>
            ● “Live”: refers to the functionality allowing the broadcast of a Live Media through the Platform. Access to a Creator’s Live can be free
            or paid;
          </Typography.Paragraph>
          <Typography.Paragraph>
            ● ” mandatary”: means any person, natural or legal, mandated by the Creator, whether representation agencies or marketing agencies for
            example, who are entrusted with services contributing to the provision of Media via the Platform. The Agent may, directly or indirectly,
            have an activity on the Creator’s Account for the purposes of the service provided to the Creator.
          </Typography.Paragraph>
          <Typography.Paragraph>
            ● “Media”: means all photographs, videos, music, audio files, podcast, Lives, information, texts, logos, brands, animations, drawings and
            models, data and in general all elements and content created by a Creator and published by the latter under his sole responsibility on the
            Platform according to the terms, form and conditions offered to him as part of the Services;
          </Typography.Paragraph>
          <Typography.Paragraph>
            ● “Public Media”: means any Media published by the Creator on his Profile and accessible to any User, free of charge;
          </Typography.Paragraph>
          <Typography.Paragraph>
            ● “Non-Public Media”: means any Media communicated on the Profile, in a blurred way. The Non-Public Media can be a viewable Media against
            a Subscription, a Private Media, a Push Media or a Live;
          </Typography.Paragraph>
          <Typography.Paragraph>
            ● “Private Media” or “Personalized Media”: means any Media exchanged by a Creator and a User, through messaging. The Private media must in
            principle correspond to the Specifications requested by the User. Private Media cannot appear in the Creator’s profile;
          </Typography.Paragraph>
          <Typography.Paragraph>
            ● “Media Push”: means any Media spontaneously proposed by a Creator to one or more Users, through private messaging;
          </Typography.Paragraph>
          <Typography.Paragraph>● “Twizz” or “the Operator”: Means indiscriminately the Operator or the Platform herein.</Typography.Paragraph>
          <Typography.Paragraph>
            ● “Parties”: in the plural, designates Twizz and the User together. In the singular, designates only one of the two Parties;
          </Typography.Paragraph>
          <Typography.Paragraph>
            ● “Platform”: means the Online Platform accessible at the following address: https://${APP_DOMAIN}/ or by the corresponding mobile
            applications. The Platform includes all the web pages, Services and functionalities offered to Users;
          </Typography.Paragraph>
          <Typography.Paragraph>
            ● “Price”: means the amount of money or crypto assets paid by a User to the Creator through the Platform in return for a Subscription or
            Media;
          </Typography.Paragraph>
          <Typography.Paragraph>
            ● “Profile”: refers to the Creator’s presentation page, in which both the latter’s activity and the Media and Subscriptions he offers are
            presented;
          </Typography.Paragraph>
          <Typography.Paragraph>
            ●”A tip”: means the amount freely paid by the User to the Creator at his sole discretion, without direct consideration;
          </Typography.Paragraph>
          <Typography.Paragraph>● “Services”: refers to all the Services offered by the Operator to Users through the Platform;</Typography.Paragraph>
          <Typography.Paragraph>
            ● “Support Site”: means the website hosted at https://support.${APP_DOMAIN}/, edited by the Operator in order to provide maximum
            information and assist any User in his use of the Platform and its Services;
          </Typography.Paragraph>
          <Typography.Paragraph>
            ● “Specifies”: refers to the characteristics of a Private Media, proposed by a Creator or required by a User when making the request. Any
            Private Media that is the subject of an Order on the Platform must comply with the Specifications agreed between the User and the Creator;
          </Typography.Paragraph>
          <Typography.Paragraph>
            ● “Story”: refers to the Media published by the Creator to illustrate its topicality, which will automatically disappear after a period of
            seventy-two (72) hours;
          </Typography.Paragraph>
          <Typography.Paragraph>
            ● “SuperStar”: means any Creator who meets the criteria defined on the Support Site (https://support.${APP_DOMAIN}/) and as such benefits
            from differentiated treatment;
          </Typography.Paragraph>
          <Typography.Paragraph>● «Ticket”: refers to the ticket ordered by a User and allowing him to attend a Live;</Typography.Paragraph>
          <Typography.Paragraph>
            ● “User”: means any person who accesses and navigates the Platform, whether he or she is a Subscriber, Creator, Ambassador or a simple
            Internet user;
          </Typography.Paragraph>
          <Typography.Paragraph>
            ● “Interested User”: means any user identified by Twizz as interested in the Media or the Creator’s Profile without having subscribed to a
            Subscription with the Creator.
          </Typography.Paragraph>
          <Typography.Paragraph>Article 2. Object</Typography.Paragraph>
          <Typography.Paragraph>
            The purpose of these T&amp;Cs, concluded between Twizz and the User, is to establish the respective rights and obligations of the Parties
            in the context of the use of the Platform and all the Services offered therein.
          </Typography.Paragraph>
          <Typography.Paragraph>
            It is understood that: – the Services expressly offered to Creators are governed by the General Conditions of Services; – the subscription
            to a Subscription or the purchase of Media is governed by the General Terms and Conditions of Sale (GTC).
          </Typography.Paragraph>
          <Typography.Paragraph>
            They also provide the User, in a clear, fair and transparent manner, with all legally mandatory information.
          </Typography.Paragraph>
          <Typography.Paragraph>Article 3. Acceptance of the General Terms and Conditions of Use</Typography.Paragraph>
          <Typography.Paragraph>The use of the features of the Platform and the Services implies acceptance of these T&amp;Cs.</Typography.Paragraph>
          <Typography.Paragraph>
            Thus, the User undertakes to carefully read these General Terms and Conditions of Use when accessing the Platform and is invited to
            download, print and keep a copy.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Any use of the Platform and a fortiori, the subscription to a Subscription or the purchase of Media implies that the User: – if he is a
            legal person, or a legally registered legal person, acting through a legal representative or a person duly authorized to engage him
            legally; – if he is a natural person, whether he is of legal age, capable, not placed under any measure of legal protection (curatelle,
            guardianship).
            <br />
            The T&amp;Cs may be resolved in the event that one of these conditions is no longer met, resulting in the suspension or even deletion of
            the User’s Account.
          </Typography.Paragraph>
          <Typography.Paragraph>Article 4. Technical specifications</Typography.Paragraph>
          <Typography.Paragraph>
            By using the Platform, the User acknowledges that he has the means and skills necessary to use the features offered on the Platform.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The equipment necessary for access and use of the Platform (telephone, computer, tablet, or any other mobile terminal, etc.) is the
            responsibility of the User, as well as the telecommunications costs that may be induced by their use.
          </Typography.Paragraph>
          <Typography.Paragraph>Article 5. Twizz’s role</Typography.Paragraph>
          <Typography.Paragraph>5.1. Twizz’s intervention as an online platform operator</Typography.Paragraph>
          <Typography.Paragraph>Twizz acts as an online platform operator.</Typography.Paragraph>
          <Typography.Paragraph>
            The Amount of the Prize is chosen by the Creator, under his sole responsibility. The Media are published by the Creator under his
            responsibility, the Operator can only act as a host of said content.
          </Typography.Paragraph>
          <Typography.Paragraph>5.2. General pre-contractual information obligation: loyalty, clarity and transparency</Typography.Paragraph>
          <Typography.Paragraph>As an online platform operator, Twizz acts in a neutral, clear and transparent manner.</Typography.Paragraph>
          <Typography.Paragraph>5.2.1. Referencing of Profiles and Content</Typography.Paragraph>
          <Typography.Paragraph>
            The criteria for referencing and ranking the Creators as well as the Media presented on the News Feed are, in accordance with the
            applicable regulations, detailed in a dedicated section, present on the Platform and/or on the Support Site.
          </Typography.Paragraph>
          <Typography.Paragraph>
            This being said, Twizz grants specific treatment to certain Creators, in this case the Superstars, who benefit from lower Commissions from
            Twizz, a highlighting of their special status thanks to a patch on their Profile, a highlighting in the search engine and the possibility
            of benefiting from certain means of payment.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Finally, some Creators, because of their great notoriety or editorial choices, can be spontaneously and momentarily put forward by Twizz.
          </Typography.Paragraph>
          <Typography.Paragraph>Search engine</Typography.Paragraph>
          <Typography.Paragraph>The User can enter keywords on the Platform’s search engine to search for Creators or Media.</Typography.Paragraph>
          <Typography.Paragraph>
            Profiles are classified in a simple order: Superstars first, then Profiles with the greatest relevance to the User’s search.
          </Typography.Paragraph>
          <Typography.Paragraph>Users will be informed of a creator’s SuperStar status through an apparent sign.</Typography.Paragraph>
          <Typography.Paragraph>News feed</Typography.Paragraph>
          <Typography.Paragraph>
            On the News Feed, the following Media are first presented at 2/3, in chronological order:
            <br />– The private and public media of the Creators to which he subscribes;
            <br />– The Public Media of the Creators to which the User has previously been Subscribed;
            <br />– The Public Media of the Creators for which the User can be considered an Interested User, since he has clicked on the button to
            subscribe to this Creator without making the payment;
            <br />
            -He placed one of the Creator’s Media in his Bookmark;
            <br />– “Liked” a Media of this Creator;
            <br />– Has chosen to “follow” this Creator from his Profile page.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The last 1/3 of the Media presented to the User consists of the Creators “suggested” by Twizz, who correspond to the User’s interests and
            tastes.
          </Typography.Paragraph>
          <Typography.Paragraph>5.2.2. Information relating to the tax obligations of Creators</Typography.Paragraph>
          <Typography.Paragraph>In accordance with Article 242 bis of the General Tax Code, Twizz undertakes to:</Typography.Paragraph>
          <Typography.Paragraph>
            -On the occasion of each transaction carried out through it, communicate to the Creators information on the tax regimes and social
            regulations applicable to these sums, the resulting reporting and payment obligations to the tax administration and social contribution
            collection agencies as well as the penalties incurred in the event of failure to comply with these obligations (cf. Annex 1: Information
            on civil and tax obligations);
            <br />– Issued once a month the summary of transactions carried out during the past month;
            <br />– Issue to the Creators in January of each year a document summarizing the gross amount of transactions of which it has become aware
            and that the Creators have received, through it, during the previous year.
          </Typography.Paragraph>
          <Typography.Paragraph>
            For more information on his tax and social obligations, the Creator is invited to consult the General Terms and Conditions of Service.
          </Typography.Paragraph>
          <Typography.Paragraph>5.3. Fight against cyber threats and cyber pimping</Typography.Paragraph>
          <Typography.Paragraph>Twizz attaches particular importance to the fight against cyber threats.</Typography.Paragraph>
          <Typography.Paragraph>
            Twizz has put in place devices to combat cyber threat and cyber pimping. These devices are detailed on the “Cyberprotection &amp; support”
            tab
          </Typography.Paragraph>
          <Typography.Paragraph>
            In order to combat these threats, Twizz is setting up:
            <br />– A system for de-anonymizing Users, allowing, if necessary, to support the police forces and to be able to make all Users
            responsible; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;– A strengthened KYC for all Users;
            <br />– Computer moderation of Media and interactions between users through artificial intelligence tools that respect Twizz’s applicable
            legal framework and host status; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            &nbsp; &nbsp;– Tools to verify the majority of Users in the event of access to Media.
          </Typography.Paragraph>
          <Typography.Paragraph>Article 6. Conditions of access and registration on the Platform</Typography.Paragraph>
          <Typography.Paragraph>
            The Internet user wishing to become a User, Creator or Ambassador is invited to follow the steps described below.
          </Typography.Paragraph>
          <Typography.Paragraph>6.1. Registration on the Platform</Typography.Paragraph>
          <Typography.Paragraph>6.1.1. Registration as a “User”</Typography.Paragraph>
          <Typography.Paragraph>
            Any User wishing to become a “User” can register by selecting the “User” tab or by visiting the following web page: https://${APP_DOMAIN}
            /app/register.
          </Typography.Paragraph>
          <Typography.Paragraph>
            To register as a “User”, the User must:
            <br />– Register with your email address or via your Facebook or Google account;
            <br />– Accept these T&amp;Cs.
          </Typography.Paragraph>
          <Typography.Paragraph>Registration via an email address</Typography.Paragraph>
          <Typography.Paragraph>
            To register according to the classic registration procedure, the User will have to select the “register with my email address” option.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The User will then have to fill in the following information on an online form:
            <br />– His pseudonym ;<br />– His date of birth ;<br />– His email address ;<br />– His password.
          </Typography.Paragraph>
          <Typography.Paragraph>Registration via a Facebook or Google account</Typography.Paragraph>
          <Typography.Paragraph>
            To register via his Facebook or Google account, the User must select the option “register with Facebook” or “register with Google”.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The User will then be redirected and will then be able to select the information he wishes to share with Twizz as part of his registration
            on the Platform. The User will also be asked to select the permissions he wishes to grant to Twizz on his Facebook or Google account.
            <br />
            The User guarantees that the Facebook or Google account used to register is his personal and nominative account, and that all information
            transmitted by Facebook or Google to Twizz is accurate, complete and up-to-date.
          </Typography.Paragraph>
          <Typography.Paragraph>6.1.2. Registration as a “Creative”</Typography.Paragraph>
          <Typography.Paragraph>
            To register as a Creator, the User must go to the https://creators.${APP_DOMAIN}/app/register page or click on the “Creators” tab and
            follow the detailed steps on the Platform.
          </Typography.Paragraph>
          <Typography.Paragraph>
            To register as a “Creative”, the User must: – Register with your email address or via your Facebook or Google account;
          </Typography.Paragraph>
          <Typography.Paragraph>
            In order to be accepted as a Creator on the Platform, the latter must submit to Twizz the elements requested on this occasion.
          </Typography.Paragraph>
          <Typography.Paragraph>
            If the data provided complies with Twizz’s expectations, the General Terms and Conditions of Service will be definitively concluded with
            Twizz. The Creator will then be considered “certified” and will be able to publish Media on the Platform.
          </Typography.Paragraph>
          <Typography.Paragraph>6.1.3. Registration as “Ambassador”</Typography.Paragraph>
          <Typography.Paragraph>
            To register as an Ambassador, the User must go to the https://ambassadors.${APP_DOMAIN}/app/register page and follow the detailed steps on
            the Platform or within the General Conditions of Sponsorship.
          </Typography.Paragraph>
          <Typography.Paragraph>6.2. Account access and management</Typography.Paragraph>
          <Typography.Paragraph>Once his registration is finalized, the User will have an Account on the Platform.</Typography.Paragraph>
          <Typography.Paragraph>
            The User may, if he wishes, personalize his Account, in particular by changing his pseudonym, password or by integrating a profile
            picture.
            <br />
            As such, the User undertakes never to use a profile photograph likely to infringe public order and morality in any way, in particular by
            infringing the rights of others, or by being illegal or unlawful. The User undertakes to provide Twizz, via his Account, with accurate,
            fair and up-to-date data, which does not infringe, in any way whatsoever, the rights of third parties and to communicate to Twizz any
            necessary update of the data communicated during his registration.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The User is fully responsible for the accuracy and updating of the data communicated as part of the opening and management of his Account.
          </Typography.Paragraph>
          <Typography.Paragraph>6.3. Management of Identifiers</Typography.Paragraph>
          <Typography.Paragraph>The email address and password constitute the User’s Identifiers.</Typography.Paragraph>
          <Typography.Paragraph>
            The User undertakes to create only one Account on the Platform (except in the event that the User is also Creator and/ Ambassador)). Twizz
            declines all responsibility for the harmful consequences that the use of multiple Accounts for a single User may have.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The User will be solely responsible for the use of his Identifiers or the actions carried out through his Account, regardless of the
            actions carried out through the Identifiers.
          </Typography.Paragraph>
          <Typography.Paragraph>
            In the event that a User discloses or uses his Credentials in a manner contrary to their destination, Twizz may then delete his Account
            without notice or compensation.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Under no circumstances can Twizz be held responsible in the event of theft of a User’s identity. Any access and action carried out from a
            User’s Account will be presumed to be carried out by that User, insofar as Twizz has no obligation and does not have the technical means
            to ensure the identity of the persons accessing the Platform from an Account.
          </Typography.Paragraph>
          <Typography.Paragraph>
            In the event of loss or forgetting his password, the User must reset it without delay by using the “forgotten password” button and then
            entering the email address previously indicated and linked to his Account.
            <br />
            Any unauthorized misuse or use of a User’s Identifiers and their consequences are the sole responsibility of the User, the latter being
            obliged to notify Twizz, without delay, by electronic message addressed to the following address: support@${APP_DOMAIN}.
          </Typography.Paragraph>
          <Typography.Paragraph>6.3.1. Case of Agents</Typography.Paragraph>
          <Typography.Paragraph>
            Any Agent of a Creator is required to declare this without delay to Twizz by writing to support@${APP_DOMAIN}.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Creators may use Agents, whether representation agencies or marketing agencies who are entrusted with services contributing to the
            provision of Media via the Platform.
          </Typography.Paragraph>
          <Typography.Paragraph>
            In such a case, the Creator acknowledges that as an agent or principal, he will be fully responsible for any action carried out via his
            Account, whether undertaken by the Creator himself or by his Agent.
          </Typography.Paragraph>
          <Typography.Paragraph>6.4. Account Certification</Typography.Paragraph>
          <Typography.Paragraph>
            The certification of the Account makes it possible to report its authenticity to other Users. Users may request the certification of their
            Account under the conditions set out below.
          </Typography.Paragraph>
          <Typography.Paragraph>6.4.1. User Account Certification</Typography.Paragraph>
          <Typography.Paragraph>
            Users will be able to request the certification of their Account with Twizz by following the steps detailed below:
            <br />
            -Complete personal information;
            <br />– Valid proof of identity;
            <br />– Security selfie and/or submission to age verification technology;
            <br />– Telephone number confirmed by double authentication;
          </Typography.Paragraph>
          <Typography.Paragraph>
            If the account is linked to a natural or legal person acting in a professional capacity:
            <br />– The company’s registration certificate;
            <br />– If applicable, the intra-Community VAT number.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Twizz will analyze the User’s request for certification and reserves the right to refuse any request that does not meet the criteria
            indicated above.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Users are informed that Twizz may revoke the certification of their Account without notice or compensation when the User no longer meets
            the above criteria in the event of a serious or repeated breach of these General Terms and Conditions of Use and in particular in the
            event of:
            <br />– Theft of the identity of a third party;
            <br />– Serious failure resulting in the suspension of the Account.
          </Typography.Paragraph>
          <Typography.Paragraph>6.4.2. Creator Account Certification</Typography.Paragraph>
          <Typography.Paragraph>
            The conditions under which the Creator’s Account can be certified are described in the General Terms and Conditions of Service.
          </Typography.Paragraph>
          <Typography.Paragraph>6.5. Deletion of the Account</Typography.Paragraph>
          <Typography.Paragraph>6.5.1. Deletion of the User or Ambassador Account</Typography.Paragraph>
          <Typography.Paragraph>At any time, the User may send a request to Twizz to obtain the deletion of his Account.</Typography.Paragraph>
          <Typography.Paragraph>
            This request can be made automatically through the “account deletion” section of the User’s Account.
          </Typography.Paragraph>
          <Typography.Paragraph>
            This request can also be made by email to: support@${APP_DOMAIN}, indicating ” DELETION” in the subject of the email, and must be sent
            from the email address associated with the Account.
          </Typography.Paragraph>
          <Typography.Paragraph>
            In the event of sending a request in the forms prescribed in this article, Twizz undertakes to delete the account, and all related
            information.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Any request to delete the Account is final, and does not give rise to any refund, regardless of the subscription periods paid in advance.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The User understands and accepts that the use of the deletion of the Account by request sent by email necessarily entails a processing
            time longer than the automated deletion through the form present on the User’s Account.
          </Typography.Paragraph>
          <Typography.Paragraph>6.5.2. Deletion of the Creator Account</Typography.Paragraph>
          <Typography.Paragraph>
            The conditions under which Creators can delete their Account are specified in the General Terms and Conditions of Service.
          </Typography.Paragraph>
          <Typography.Paragraph>Article 7. Description of the Services</Typography.Paragraph>
          <Typography.Paragraph>7.1. Services provided to any User</Typography.Paragraph>
          <Typography.Paragraph>
            Any User can access the Platform free of charge, as well as its various features, subject to registering in advance.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The main Service offered by Twizz is to offer any registered User the opportunity to consult the Creators’ Profiles referenced on the
            Platform as well as the Media published by them.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Users can access:
            <br />– To the Platform’s search engine to search for a Media or a Creator;
            <br />– To their News Feed.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Registered Users automatically have access to:
            <br />– To the Public Profile of the Creators;
            <br />– To the Public Media published by the Creators on the Platform;
            <br />
            -To the blurred version of the Non-Public Media and Push Media published by the Creators.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Users can also:
            <br />– Like the content by clicking on the Like button;
            <br />– Add Creators or Media to their Bookmark.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Full access to the Creators’ Non-Public and Private Media and their Profile is reserved for Users who have subscribed to a Subscription
            with the Creator concerned and who have paid the payment of the Price set by the Creator.
          </Typography.Paragraph>
          <Typography.Paragraph>7.2. Services provided to Users</Typography.Paragraph>
          <Typography.Paragraph>7.2.1. Access to Non-Public Media</Typography.Paragraph>
          <Typography.Paragraph>
            Creators will first of all be able to publish Public Media, accessible free of charge by any User.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The “public” nature of the Content does not imply any transfer of intellectual property rights to Users who must in any case refrain from
            publishing the content on other media, whatever they may be or communicating them to third parties in any way.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The ephemeral nature of the Stories will in no way limit the Creator’s responsibility for the content of the published Media.
          </Typography.Paragraph>
          <Typography.Paragraph>7.2.2. Access to Non-Public Media</Typography.Paragraph>
          <Typography.Paragraph>Generalities</Typography.Paragraph>
          <Typography.Paragraph>Non-Public Media appear blurred on the Platform.</Typography.Paragraph>
          <Typography.Paragraph>
            To access the non-blurred version of the Non-Public Media, the User must subscribe to a Subscription with the Creator who published the
            said Media by following the steps detailed in the General Terms and Conditions of Sale.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The rights conferred by the Subscription and the Price of the Subscription or Media are detailed on its Profile and are defined by the
            Creator, under his sole responsibility.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Subscription to Non-Public Media as well as any access (paid or free) to a Media are governed by the General Terms and Conditions of Sale.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Each Subscription is only valid for the Creator with whom the User has subscribed to a Subscription.
            <br />
            It is specified that the Creators:
            <br />– Publish the Media under their sole responsibility;
            <br />
            -Undertake not to broadcast in any way all or part of the Non-Public Media on other non-paid platforms or social networks.
          </Typography.Paragraph>
          <Typography.Paragraph>
            As a platform operator, Twizz has no control over the frequency, quality and quantity of the Media published by the Creators, who carry
            out their activity independently.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Before subscribing to a Subscription, it is therefore up to the User to carry out research on each Creator, relating in particular to
            their activity and the frequency of their publications.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The User undertakes to use the Media in compliance with these T&amp;Cs and in particular not to publish the Media on other platforms and
            social networks and/or not to communicate them to any third party.
          </Typography.Paragraph>
          <Typography.Paragraph>Access to Push Media</Typography.Paragraph>
          <Typography.Paragraph>
            The Creator may also publish Push Media on the Platform under his sole responsibility and full control.
          </Typography.Paragraph>
          <Typography.Paragraph>
            To access the Push Media, the User must:
            <br />– If the Media Push is paid, have subscribed to a Subscription with the Creator concerned;
            <br />– If necessary, pay the corresponding Price under the conditions provided for and detailed in the General Terms and Conditions of
            Sale.
          </Typography.Paragraph>
          <Typography.Paragraph>Access to the Lives</Typography.Paragraph>
          <Typography.Paragraph>The Creator will also be able to broadcast Lives on the Platform.</Typography.Paragraph>
          <Typography.Paragraph>
            It is specified that Users are automatically invited to participate in the Lives. The Creator may also, in his sole discretion, invite his
            former Users as well as Interested Users to attend his Lives.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The modalities of broadcast of the Live (free, paid, schedules, duration…) are freely defined by the Creator under his control and sole
            responsibility and are communicated to the User by means of an invitation.
          </Typography.Paragraph>
          <Typography.Paragraph>
            When the Live is paid, the User must purchase a Ticket under the conditions detailed by the General Terms and Conditions of Sale.
          </Typography.Paragraph>
          <Typography.Paragraph>
            It is specified that the Creator will be able to activate and deactivate the Chat at any time during his Live.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The User undertakes to:
            <br />– Use the Chat in compliance with the rules of courtesy, politeness and savoir-vivre, as well as the rules recalled herein;
            <br />– Respect the rules for the use of the Chat defined by the Creator concerned.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The User is informed that in the event of a breach of his obligations hereunder or the rules defined by the Creator, the latter may, under
            his sole responsibility:
            <br />– Mute it. In this case, the Creator and other Users will no longer be able to see the messages posted by the User ;<br />
            -Banish him from the Cat for the duration of his choice. Only the Creator may decide to revoke the exclusion of the Cat under his sole
            responsibility.
          </Typography.Paragraph>
          <Typography.Paragraph>7.2.3. Access to Messaging</Typography.Paragraph>
          <Typography.Paragraph>
            Users will be able to use Messaging to communicate with the Creator with whom they have subscribed to a Subscription.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Messaging can be used to: – Communicate with the Creator; – Request or communicate Private Media to the Creator.
          </Typography.Paragraph>
          <Typography.Paragraph>
            It is recalled that it is strictly forbidden to request or exchange with the Creator personal contact information, whether it is a
            telephone number, an email address, a postal address or geolocation data.
          </Typography.Paragraph>
          <Typography.Paragraph>7.2.4. Private Media Request</Typography.Paragraph>
          <Typography.Paragraph>
            Users may use Messaging to request from the Creator to whom they are subscribed the communication of a Private Media by following the
            steps detailed on the Platform and/or within the General Terms and Conditions of Sale.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The conditions of sale and the Private Media Specifications are freely defined between the User and the Creator, via Messaging. In the
            absence of specific agreed conditions, the General Terms and Conditions of Sale will apply.
          </Typography.Paragraph>
          <Typography.Paragraph>
            In any case, Users are informed that:
            <br />– The Creator will have no obligation to respond to the User’s request ;<br />– The Creator may reuse the Private Media created by
            him on the Platform provided that he does not distribute it free of charge on the Platform or on any other medium in the form of Public
            Media or freely accessible content. Thus, except for specific conditions agreed between the User and the Creator, the communication of a
            Private Media does not necessarily imply that it is “unique” or communicated exclusively to the User concerned.
          </Typography.Paragraph>
          <Typography.Paragraph>7.2.5. Tips</Typography.Paragraph>
          <Typography.Paragraph>To support Creators, Users will have the opportunity to offer them Tips.</Typography.Paragraph>
          <Typography.Paragraph>These winnings will be credited to the Creator’s account in the same way as the other winnings.</Typography.Paragraph>
          <Typography.Paragraph>
            7.2.6. Payment to associations
            <br />
            The Creator has the possibility, when he creates his account, to choose an association to which he would like to donate part of his
            earnings.
          </Typography.Paragraph>
          <Typography.Paragraph>
            It is understood that if Twizz encourages the Creator to donate part of these gains to this type of charitable initiation, Twizz does not
            intervene in the repayment of the sums to them so that the Creator will be solely required to respect the commitments made to both Users
            and associations. The Creator therefore undertakes to pay to the chosen association, without the assistance of Twizz, the percentage of
            his commissions that he has committed to donate. Twizz can under no circumstances be held responsible for a Creator who ultimately does
            not pay the share of his Commissions to go to the association.
          </Typography.Paragraph>
          <Typography.Paragraph>
            7.2.7. Contest Games
            <br />
            Any Creator offering a contest via the Platform does so under his full responsibility and is therefore responsible for complying with the
            applicable regulations in this area.
          </Typography.Paragraph>
          <Typography.Paragraph>
            For example, the Creator may be required to provide game rules to provide loyal information to Users on the conditions of participation in
            the game.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Any contest organized directly by Twizz, if necessary in partnership with a Creator, will be visible in the Annex to these T&amp;Cs.
          </Typography.Paragraph>
          <Typography.Paragraph>7.3. Services provided to Creators</Typography.Paragraph>
          <Typography.Paragraph>The Services provided to Creators are detailed in the General Terms of Service.</Typography.Paragraph>
          <Typography.Paragraph>7.4. Services provided to Ambassadors</Typography.Paragraph>
          <Typography.Paragraph>The Services provided to Ambassadors are detailed in the General Conditions of Sponsorship.</Typography.Paragraph>
          <Typography.Paragraph>7.5. Evolution of Services and updates</Typography.Paragraph>
          <Typography.Paragraph>
            Twizz reserves the right to freely evolve the Services, at its sole discretion, in particular in order to improve the Platform and
            existing Services.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Twizz ensures that the User is informed of the updates necessary to maintain the compliance of the Service for the duration of the
            T&amp;Cs. &nbsp;When the update requires an installation by the User, Twizz will inform the User of the availability of updates, the terms
            of their installation and the consequences of their non-installation. Failing to install by the User within a reasonable time, Twizz
            cannot be held liable for defects in conformity resulting from the failure to update.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Twizz may also carry out updates to the Service not necessary for its maintenance of the Service but allowing the improvement of its
            operation, the proposal of additional functionalities, the strengthening of the security of the Services or the adaptation to technical or
            regulatory developments.
          </Typography.Paragraph>
          <Typography.Paragraph>
            These updates will be the subject of information from the Customer specifying the date of their entry into force.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The User may refuse the update or uninstall it later if it affects his access to the Platform. Unless the update has only a minor impact
            on the User or Twizz has allowed him to keep the Platform without the update, he will be able to resolve the T&amp;Cs as of right and free
            of charge, within a maximum period of thirty (30) days after the implementation of the update.
          </Typography.Paragraph>
          <Typography.Paragraph>Article 8. Obligations of the Parties</Typography.Paragraph>
          <Typography.Paragraph>8.1. Obligations of Users</Typography.Paragraph>
          <Typography.Paragraph>8.1.1. Code of conduct</Typography.Paragraph>
          <Typography.Paragraph>
            Twizz pays particular attention to the establishment of a climate of trust between Creators and Users.
          </Typography.Paragraph>
          <Typography.Paragraph>
            When browsing the Platform, and in particular when sending Private Media requests, the User undertakes and guarantees that he will not
            violate any legal or regulatory provisions, and that he will not behave contrary to public order and morality.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The User undertakes to respect the rules of politeness, courtesy and savoir-vivre in the context of his interactions with the Creator and
            other Users.
          </Typography.Paragraph>
          <Typography.Paragraph>
            In particular, the User refrains from any message and behavior :<br />– Including hateful content, inciting hatred, defamatory, containing
            insults or insults ;<br />– Constitutive of harassment;
            <br />– Endorsing or encouraging any form of discrimination on the basis of race, ethnic origin, religion, disability, sex, age, sexual
            orientation or identity, physical appearance.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The User is also prohibited from paying sums of money to the Creator outside the Platform for services or services carried out on the
            Platform.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The User is informed that without prejudice to its obligation of confidentiality, Twizz may verify the content of communications between
            the User and the Creator, at the request of the Creator concerned.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Consequently, any abusive behavior proven against the Creators, in particular during exchanges relating to the communication of Private
            Media, will result in an immediate suspension of the User’s Account, without prejudice to any legal action that may be brought, and any
            damages that may be claimed by the Creator or Twizz, if applicable.
          </Typography.Paragraph>
          <Typography.Paragraph>8.1.2. Use of Media</Typography.Paragraph>
          <Typography.Paragraph>General Stipulations</Typography.Paragraph>
          <Typography.Paragraph>
            The Media is and remains the exclusive property of the Creator who publishes it under his full control and sole responsibility.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Unless expressly agreed in writing by the Creator, the publication of the Media by the Creator on the Platform does not confer any right
            of ownership of any kind over the Media for the benefit of other Users, nor any authorization to exploit the Creator’s right to the image
            in any way whatsoever, which the User expressly accepts and acknowledges.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Consequently, the User undertakes to:
            <br />– Use the Media published by other Users only for his personal needs for the purpose of consulting the Media on the Platform,
            excluding any use of the Media for commercial or professional purposes ;<br />– Do not publish, broadcast or communicate all or part of
            the Media published by another User to third parties, by any means whatsoever, on any medium whatsoever, in particular on social networks,
            whether free of charge or for a fee ;<br />– Do not modify, adapt or infringe the integrity of all or part of the Media published by
            another user in any way.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Any download, sharing, provision, reproduction, or any other form of reproduction, use or dissemination excluding consultation on the
            Platform infringes the rights of the Creator, Twizz or the User and engages the responsibility of the User.
          </Typography.Paragraph>
          <Typography.Paragraph>
            In the event of a serious suspicion of breach of these obligations, Twizz may suspend or even delete the User’s Account for its exclusive
            faults, without any refund for the sums paid by the User being payable by the latter.
          </Typography.Paragraph>
          <Typography.Paragraph>
            In the event of a proven breach of these commitments, which are part of the essential commitments of the Parties, the User undertakes to
            pay Twizz a lump sum of five hundred euros (€500) excluding taxes.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The payment of this penalty is non-discharging and does not exclude the User’s liability for the violation of the Creator’s rights, who
            will in any case retain the right to claim compensation for his entire damage resulting therefrom.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Finally, the User is informed that Twizz is mandated by the Creator to request the deletion of Media that have been republished in whole
            or in part by the User on the Platform or on any other platform, social network or medium of any kind.
          </Typography.Paragraph>
          <Typography.Paragraph>Use of Media by Creators</Typography.Paragraph>
          <Typography.Paragraph>
            Consequently, Creators may publish or broadcast all or part of Non-Public, Private, Push Media or Lives on any other platform, social
            network or medium of any kind, as long as such distribution is paid for.
          </Typography.Paragraph>
          <Typography.Paragraph>8.1.3. General obligations</Typography.Paragraph>
          <Typography.Paragraph>In general, each User has an obligation to:</Typography.Paragraph>
          <Typography.Paragraph>
            – Behave in a fair and prudent and reasonable person towards Twizz, Creators and other Users;
            <br />– Be honest and sincere in the information provided to Twizz and, where applicable, to other Users;
            <br />– Not to carry out an activity comparable to cyberbullying, or any other offence comparable to pimping, in accordance with Articles
            225-5 et seq. of the Penal Code;
            <br />– Use the Platform in accordance with its purpose as described in these T&amp;Cs;
            <br />– Do not divert the purpose of the Platform to commit crimes, offences or contraventions repressed by the penal code or any other
            law ;<br />– Respect the privacy of third parties and in particular Creators and the confidentiality of exchanges ;<br />– Respect Twizz’s
            intellectual property rights to the elements of the Platform ;<br />– Respect the property rights of Creators over the Media ;<br />– Do
            not seek to infringe within the meaning of Articles 323-1 et seq. of the Criminal Code the automated data processing systems implemented
            on the Platform ;<br />– Do not modify the information posted online by the Operator or by another User;
            <br />– Do not use the Platform to send massively unsolicited messages (advertising or otherwise);
            <br />– Not to disseminate data that has the effect of reducing, disorganize, slowing down or interrupting the normal operation of the
            Platform;
            <br />– Do not disclose in an unauthorized manner personal and/or confidential information of third parties, including Creators and other
            Users, including the surnames, first names, addresses, social media, telephone numbers, email addresses of natural persons identified by
            pseudonyms, or any other element allowing their identification, or infringing their privacy.
          </Typography.Paragraph>
          <Typography.Paragraph>
            In compliance with the legal and regulatory provisions in force and in accordance with the law of 29 July 1881 on freedom of the press,
            the User undertakes not to disseminate any message or information:
          </Typography.Paragraph>
          <Typography.Paragraph>
            -Constitutive of wrongful denigration against the Operator or Users of the Platform;
            <br />– Contrary to public order and morality ;<br />– Of an abusive, defamatory, racist, xenophobic, revisionist or damaging the honor or
            reputation of others; – Inciting discrimination, hatred of a person or group of people because of their origin or membership or
            non-membership of a particular ethnic group, nation, race or religion ;<br />– Threatening a person or a group of people ;<br />–
            Pededophile ;
          </Typography.Paragraph>
          <Typography.Paragraph>
            – Sexual or Pornographic Content: The integration of any kind of sexual or pornographic content is prohibited.
            <br />– Inciting to commit an offence, crime or act of terrorism or advocating war crimes or crimes against humanity; – Inciting suicide ;
            <br />– Allowing third parties to obtain directly or indirectly pirated software, software serial numbers, software allowing acts of
            piracy and intrusion into computer and telecommunications systems, viruses and other logic bombs and generally any software or other tool
            to infringe the rights of others and the safety of persons and property ;<br />– Commercial in nature (prospecting, soliciting,
            prostitution…).
          </Typography.Paragraph>
          <Typography.Paragraph>8.1.4. Reports</Typography.Paragraph>
          <Typography.Paragraph>
            As part of its active fight against Illicit Content, Twizz has set up a set of computer tools to detect, before their publication, Content
            that could be considered “illegal”. However, since these technologies are not infallible, and Twizz cannot be bound by an obligation of
            systematic control, Twizz has put in place a strong notification system to promptly remove any Content that may prove illegal.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The User undertakes to report any observed violation of these T&amp;Cs, or of the French or foreign legislation in force in Twizz, through
            the “…” report button visible at the top right of the Media, or by contacting Twizz directly at support@${APP_DOMAIN}.
          </Typography.Paragraph>
          <Typography.Paragraph>8.2. Twizz’s obligations</Typography.Paragraph>
          <Typography.Paragraph>8.2.1. General provisions</Typography.Paragraph>
          <Typography.Paragraph>
            First of all, in accordance with the Law on Confidence in the Digital Economy, as a host, Twizz has an obligation to contribute to the
            fight against the dissemination of the offences referred to in the fifth, seventh and eighth paragraphs of Article 24 and Article 24 bis
            of the Law of 29 July 1881 on Freedom of the Press and Articles 222-33,222-33-2-3,225-4-1,225-4-13,225-5,225-6,227-23 and 227-24 and
            421-2-5 of the Criminal Code.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Twizz thus undertakes to promptly inform the competent public authorities of any illegal activities reported to them and carried out by
            any User of the Platform.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Twizz’s general obligation is an obligation of means. There is no obligation on Twizz to result or reinforced means of any kind.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Twizz is committed to implementing all means to ensure continuity of access and use of the Platform 7 days a week and 24 hours a day.
            &nbsp;However, Twizz draws the attention of Users to the fact that current communication protocols via the Internet do not make it
            possible to ensure the certain and continuous transmission of electronic exchanges (messages, documents, identity of the sender or
            recipient).
          </Typography.Paragraph>
          <Typography.Paragraph>
            In the event that the Platform is unavailable for more than 7 consecutive days within the same month, Users may request a refund of their
            Subscription from Twizz by sending an email to support@${APP_DOMAIN}.
          </Typography.Paragraph>
          <Typography.Paragraph>
            In addition, in accordance with the provisions of Articles L.111-7 et seq. of the Consumer Code, as an online platform operator, the
            Operator undertakes to provide clear, transparent and fair information on the modalities of its intervention, in particular within the
            present.
          </Typography.Paragraph>
          <Typography.Paragraph>8.2.2. Fight against the exploitation of human beings and Content Policy</Typography.Paragraph>
          <Typography.Paragraph>
            The Operator has put in place a Content Policy and an Anti-exploitation Policy, accessible from the Platform. Twizz invites all its Users
            to consult these documents. The user confirms that the merchant has disclosed the prohibition of any activity that promotes or facilitates
            human trafficking, sex trafficking, child pornography, incest, bestiality, rape, non-consensual mutilation of a person or body part.
          </Typography.Paragraph>
          <Typography.Paragraph>
            In this context, Twizz recalls that it is putting in place a set of measures to ensure that these requirements are met.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Regarding potentially illegal content, any Media is analyzed by an artificial intelligence solution when it is downloaded, before it is
            published. The artificial intelligence solution can thus block the distribution of any illegal content, contrary to the Content Policy or
            the Anti-Exploitation Policy.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Regarding the verification of the majority of Creators, the age of any Creator is verified, by means of his identity document and a selfie
            where the creator holds his identity document in his hand. This data is processed and hosted by an artificial intelligence solution,
            managed by a third-party company.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Regarding the integrity of consent and the majority of third parties appearing on the content, Twizz implements verification processes:
            &nbsp; &nbsp; &nbsp; &nbsp; ● When downloading a Media, the Creator guarantees that the latter does not present any other third party or,
            if applicable, that he guarantees to have proof of the integrity of the person’s consent and his or her majority;
            <br />● If a Creator offers content featuring several third parties, then he may be required to provide proof of the consent of these
            people (transfer of image rights and authorization for dissemination);
            <br />● Twizz requires from any agency, which would present itself as the agent of a creator registered on the Platform, a formal contract
            concluded with the principal creator, containing a transfer of the right to the image and an authorization to broadcast.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Regarding the verification of the age of Users wishing to have access to a Media, if the user already declares on his honor that he is of
            legal age when registering, he must also submit to a control carried out by an artificial intelligence solution when he tries to have
            access to such content. This solution is based on the analysis of facial features in real time to determine the user’s real age. If the
            age assessment leaves uncertainty, then the User can contact the support service to prove his age by any means.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Twizz then sets up random controls, allowing him, for example, to analyze the content in more depth.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Finally, in accordance with its status as a host, Twizz acts promptly on any content that is notified to it because of its potentially
            illegal nature. Each Media appears a button allowing any User to make a proper notification of illegal content which, if necessary, may
            lead to the deletion of the Media in the event of manifestly illegal content, or to requests for deletion from the Creator concerned.
          </Typography.Paragraph>
          <Typography.Paragraph>8.2.3. Legal guarantee of conformity</Typography.Paragraph>
          <Typography.Paragraph>
            Users who are a consumer benefit from legal guarantees as defined by Articles L.224-25-12 and following of the Consumer Code.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The content and conditions for the implementation of the legal guarantee of conformity are specified in the Annex hereto.
          </Typography.Paragraph>
          <Typography.Paragraph>Article 9. Liability</Typography.Paragraph>
          <Typography.Paragraph>9.1. Responsibility of Twizz</Typography.Paragraph>
          <Typography.Paragraph>9.1.1. General principles</Typography.Paragraph>
          <Typography.Paragraph>Twizz declines all responsibility in particular:</Typography.Paragraph>
          <Typography.Paragraph>
            – In case of impossibility to temporarily access the Platform for technical maintenance or updating of published information. Users
            acknowledge that Twizz cannot be held liable in the event of malfunctions or interruptions of the said transmission networks ;<br />– In
            the event of malfunctions or interruption of the User’s computer equipment ;<br />– In the event of viral attacks or unlawful intrusion
            into an automated data processing system ;<br />– In the event of abnormal use or illegal exploitation of the Platform by a User or a
            third party;
            <br />– Relating to the content of third-party websites to which hypertext links on the Platform refer;
            <br />– Relating to the Media published or communicated by Users as well as the Lives broadcast by them;
            <br />– Relating to the execution of the Sponsorship contract concluded between the Ambassador and a Creator or another Ambassador;
            <br />
            -In the event of non-compliance with these T&amp;Cs attributable to Users;
            <br />– In the event of delay or non-performance of its obligations, when the cause of the delay or non-performance is related to a case
            of force majeure as defined in these T&amp;Cs;
            <br />– In the event of a foreign cause not attributable to Twizz ;<br />– In the event of a Creator’s failure to comply with the
            applicable regulations and in particular with the professional or ethical rules of his profession ;<br />– In the event of unlawful action
            by a User, or contractual non-performance of which a User would have been guilty, and more particularly in the event of contractual
            non-performance of the contract concluded between the User and the Creator ;<br />– In the event of non-payment of the Subscription Price
            or Media Price by the User.
          </Typography.Paragraph>
          <Typography.Paragraph>
            In the event of abnormal use or illegal exploitation of the Platform, the User is then solely responsible for the damage caused to third
            parties and the consequences of any claims or actions that may result from it.
          </Typography.Paragraph>
          <Typography.Paragraph>9.1.2. Host status</Typography.Paragraph>
          <Typography.Paragraph>
            Users recognize that Twizz has the status of host within the meaning of Article 6 I 2° of the Law of 21 June 2004 for confidence in the
            digital economy known as LCEN.
          </Typography.Paragraph>
          <Typography.Paragraph>
            As such, Twizz reserves the right to remove from the Platform any Media that has been reported to it and that it will consider manifestly
            illegal within the meaning of Article 6 I 2° of the LCEN.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The notification of manifestly illegal content by a User or any other third party must be done by clicking on the “…” symbol visible on
            the Content or by email to the address: support@${APP_DOMAIN}.
          </Typography.Paragraph>
          <Typography.Paragraph>
            In accordance with Article 6 I 5° of the LCEN, the notification, to be valid, must include the following elements:
          </Typography.Paragraph>
          <Typography.Paragraph>
            1. The date of notification ;<br />
            2. If the notifier is a natural person: his surname, first names, profession, domicile, nationality, date and place of birth; if the
            applicant is a legal person: his form, name, registered office and the body that legally represents him ;<br />
            3. The name and address of the recipient or, in the case of a legal person, his name and registered office ;<br />
            4. The description of the disputed facts and their precise location ;<br />
            5. The reasons why the content must be removed, including the mention of legal provisions and justifications of facts ;<br />
            6. A copy of the correspondence addressed to the author or publisher of the disputed information or activities requesting their
            interruption, removal or modification, or justification that the author or publisher could not be contacted.
          </Typography.Paragraph>
          <Typography.Paragraph>9.1.3. Disputes between Users</Typography.Paragraph>
          <Typography.Paragraph>
            The Creator, by using the Platform to publish Media, acknowledges that he engages Twizz’s brand image. The Creator therefore acknowledges
            that his actions, which would not comply with all the obligations stipulated in this Agreement, may have a detrimental effect on Twizz.
          </Typography.Paragraph>
          <Typography.Paragraph>
            In the event of a dispute between a Creator and a User, the latter have access to Messaging to exchange between them in order to resolve
            the dispute between them.
          </Typography.Paragraph>
          <Typography.Paragraph>Twizz invites Users to make their best efforts to amicably resolve any dispute between them.</Typography.Paragraph>
          <Typography.Paragraph>
            In the event that the User or Users do not reach an agreement, each of the Users concerned may contact Twizz through Twizz customer
            support. Mandated for this purpose by the Creators, Twizz will then intervene to try to propose a solution to Users.
          </Typography.Paragraph>
          <Typography.Paragraph>The solution proposed by Twizz will be imposed on both the Creator and the User.</Typography.Paragraph>
          <Typography.Paragraph>9.2. User Responsibility</Typography.Paragraph>
          <Typography.Paragraph>9.2.1. Generalities</Typography.Paragraph>
          <Typography.Paragraph>
            The User is solely responsible for his use of the Platform and the Media, which he expressly accepts and acknowledges.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The User is informed that Twizz is mandated by the Creators to obtain the removal of Media that would be published by Users on other
            sites, platforms or social networks in violation of these T&amp;Cs.
          </Typography.Paragraph>
          <Typography.Paragraph>9.2.2. Suspension of the Account</Typography.Paragraph>
          <Typography.Paragraph>
            In the event of a serious and/or repeated breach by a User of his obligations, Twizz may automatically suspend access to his Account
            without delay.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The suspension will be notified to the User by email to the email address provided when registering on the Platform.
          </Typography.Paragraph>
          <Typography.Paragraph>
            In the event that the User has already been subject to several suspensions during the last three (3) years, Twizz reserves the right to
            unilaterally delete his Account and ban him from the Platform.
          </Typography.Paragraph>
          <Typography.Paragraph>
            It is specified that the suspension of the Creator’s Account is governed by the General Conditions of Service.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The suspension of the Account makes it impossible to have access to the Content, whether Subscriptions or Media, without the User being
            entitled to any compensation.
          </Typography.Paragraph>
          <Typography.Paragraph>9.2.3. Deletion of the Account</Typography.Paragraph>
          <Typography.Paragraph>
            Any suspension of an Account may give rise, as of right and without delay, to the immediate termination hereof resulting in the definitive
            closure of the Associated Account, in the event that: &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            &nbsp; &nbsp; &nbsp; &nbsp;● The contractual breach on the basis of the suspension is of such gravity that it would prevent the
            continuation of contractual relations. In particular, they are considered to be capable of justifying immediate termination as of right :
            <br />○ Any usurpation of the identity of a third party;
            <br />○ Any request for payment outside the Platform;
            <br />○ Any request to a Creator for postal, telephone or electronic contact details (email);
            <br />○ Any judicial requisition received concerning the actions of the User;
            <br />○ Any invitation made to a User to use another platform competing with Twizz;
            <br />○ Any infringement of the intellectual property rights or image rights of a third party;
            <br />○ Any attitude constituting denigration against the Operator;
            <br />○ Any request for a physical meeting with a Creator;
            <br />○ The accumulation of several warnings over a period of less than three (3) months.
            <br />● It is proven that the User has been guilty, through the Platform, of an attempted offence or criminally sanctioned offence;
            <br />● No satisfactory response is provided by the User within ten (10) days of notification of the suspension decision.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The termination of the T&amp;Cs and the closure of the Account automatically and without delay result in the termination of any
            Subscription in force and the associated General Terms and Conditions of Sale. In the same way, any access to a previously reserved Media
            will now be prohibited.
          </Typography.Paragraph>
          <Typography.Paragraph>Article 10. Force Majeure</Typography.Paragraph>
          <Typography.Paragraph>
            Twizz’s liability cannot be implemented if the non-performance or delay in the performance of one of its obligations described in these
            T&amp;Cs results from a case of force majeure.
          </Typography.Paragraph>
          <Typography.Paragraph>
            There is force majeure in contractual matters when an event beyond the control of the debtor, which could not be reasonably foreseen at
            the time of the conclusion of the Contract and the effects of which cannot be avoided by appropriate measures, prevents the performance of
            his obligation by the debtor.
          </Typography.Paragraph>
          <Typography.Paragraph>
            If the impediment is temporary, the performance of the obligation is suspended unless the resulting delay justifies the termination of the
            Contract. If the impediment is final, the Contract is automatically terminated and the Parties are released from their obligations under
            the conditions provided for in Articles 1351 and 1351-1 of the Civil Code.
          </Typography.Paragraph>
          <Typography.Paragraph>
            In the event of one of the above-mentioned events, Twizz will endeavour to inform the User as soon as possible.
          </Typography.Paragraph>
          <Typography.Paragraph>Article 11. Intellectual property</Typography.Paragraph>
          <Typography.Paragraph>11.1. Intellectual property of any User</Typography.Paragraph>
          <Typography.Paragraph>
            The User assigns on a free and non-exclusive basis to the Operator all intellectual property rights relating to the Content and in
            particular the Media, possibly published on the Platform, under the conditions defined below:
          </Typography.Paragraph>
          <Typography.Paragraph>
            ● The right of representation, and in particular without this list being exhaustive: the right to communicate, disseminate, disclose to
            the public all or part of the Content, for internal or external communication purposes (and in particular via Twizz’s social networks),
            for advertising or promotional purposes, and by all technical means known or unknown to date.
            <br />● The right of reproduction, and in particular without this list being exhaustive: the right to establish or have established
            without limitation of any original, double, or copy of all or part of the photos and by all technical means known or unknown to date.
            <br />● The right of adaptation is subject to moral rights, without limitation of formats, colors and materials accompanied by any
            captions, texts, recordings, or additions necessary for the finalization of the photos.
          </Typography.Paragraph>
          <Typography.Paragraph>
            This assignment is valid for the whole world and for the duration of the User’s registration on the Platform, for the sole purpose of the
            operation and promotion of the Platform.
          </Typography.Paragraph>
          <Typography.Paragraph>
            This assignment expressly excludes any right to sublicense and by extension any assignment, concession or license that would be granted by
            the Operator to a third party, for a fee, without the knowledge of the Creator (excluding Subscriptions or Media sales through the
            Platform).
          </Typography.Paragraph>
          <Typography.Paragraph>11.2. Intellectual Property of Creators</Typography.Paragraph>
          <Typography.Paragraph>
            The Media published on the Platform by the Creators, including the Private Media created by the Creators, are and remain the exclusive
            property of the Creators.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Only a license of use is granted to the User, under the conditions specified by the applicable General Terms and Conditions of Sale.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The Creators guarantee that they have all the intellectual property rights and, where applicable, the image rights relating to the Media
            distributed on the Platform by them.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Except with the prior and express agreement of the Creator, the publication of the Media on the Platform, in particular via Messaging,
            does not confer any property rights of any kind on Users on the Media.
          </Typography.Paragraph>
          <Typography.Paragraph>
            In any case, Twizz cannot be held responsible for an act of counterfeiting or an infringement of the right to the image, given its simple
            status as a host of the Media published by the Creators.
          </Typography.Paragraph>
          <Typography.Paragraph>11.3. Intellectual Property of Users</Typography.Paragraph>
          <Typography.Paragraph>
            The Media published by Users on their Profile or communicated to Creators as Private Media are and remain the exclusive property of Users.
          </Typography.Paragraph>
          <Typography.Paragraph>11.4. Twizz Intellectual Property</Typography.Paragraph>
          <Typography.Paragraph>
            The User acknowledges Twizz’s intellectual property rights on the Platform, its components and related elements and waives the right to
            contest these rights in any form whatsoever.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The brands, logos, slogans, graphics, photographs, animations, videos, software solutions and texts and any other Media on the Platform,
            with the exception of the Media published by Users, are the exclusive intellectual property of Twizz and may not be reproduced, used or
            represented without express authorization under penalty of legal proceedings.
          </Typography.Paragraph>
          <Typography.Paragraph>To this end, and as necessary, it is specified that Users are strictly prohibited from:</Typography.Paragraph>
          <Typography.Paragraph>
            – Reproduce, copy and/or represent, all or part of the Platform ;<br />– Translate, adapt, modify or create derivative works from all or
            part of the Platform ;<br />– Decompile, disassemble, reverse engineer all or part of the Platform ;<br />– Distribute, disseminate, sell,
            rent or lend or otherwise operate all or part of the Platform.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Any representation or reproduction, in whole or in part, of the Platform and its Media, by any means whatsoever, without the express prior
            authorization of Twizz, is prohibited and will constitute an infringement punishable by Articles L.335-2 et seq. and Articles L.713-1 et
            seq. of the Intellectual Property Code.
          </Typography.Paragraph>
          <Typography.Paragraph>In particular, Twizz expressly prohibits as a database producer:</Typography.Paragraph>
          <Typography.Paragraph>&nbsp;</Typography.Paragraph>
          <Typography.Paragraph>
            The extraction, by permanent or temporary transfer of all or a qualitatively or quantitatively substantial part of the Platform, or its
            database including the Media on another medium, by any means and in any form whatsoever; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; – The reuse, by making available to the
            public all or a qualitatively or quantitatively substantial part of the Platform or its databases including the Media or database, in any
            form;
            <br />– Reproduction, extraction or reuse, by any means, including methods similar to the scrapping of the Media or other content
            published on the Platform. Acceptance of these T&amp;Cs constitutes recognition by Users of Twizz’s intellectual property rights and
            commitment to respect them.
            <br />
            The Operator grants a personal, non-exclusive and non-askable license to Users authorizing them to use the Platform and the information it
            contains in accordance with these T&amp;Cs.
          </Typography.Paragraph>
          <Typography.Paragraph>
            This license is granted worldwide, for the entire duration of this Agreement, in return for the payment by the User of the sums to which
            he may be bound under these T&amp;Cs and/or GTC.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Any other exploitation of the Platform and its Media is excluded from the domain of this license and may not be carried out without the
            express prior authorization of the Operator.
          </Typography.Paragraph>
          <Typography.Paragraph>Article 12. Communication</Typography.Paragraph>
          <Typography.Paragraph>
            Users undertake not to use, on the Platform or on any other website, content sharing platform or social network of any kind, the
            distinctive signs of Twizz, including the name “Twizz”, in particular in the form of a hashtag in direct or indirect relation to erotic,
            pornographic or Illicit content.
          </Typography.Paragraph>
          <Typography.Paragraph>
            As such, it is recalled that it is in any case forbidden for any User, Creator as User or Ambassador to publish on the Internet a Media
            from the Platform.
          </Typography.Paragraph>
          <Typography.Paragraph>Article 13. Protection of personal data</Typography.Paragraph>
          <Typography.Paragraph>Twizz, data controller, processes Users’ personal data.</Typography.Paragraph>
          <Typography.Paragraph>
            The entire policy related to the processing of personal data implemented by Twizz is detailed in the Platform’s Privacy Policy, available
            here: https://${APP_DOMAIN}/app/privacy.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Regarding the cookies used on the Platform, the User is invited to consult the Operator’s Cookie Charter accessible on the Platform’s home
            page.
          </Typography.Paragraph>
          <Typography.Paragraph>Article 14. Use of User data</Typography.Paragraph>
          <Typography.Paragraph>
            Twizz may use any data obtained about a User’s activity to improve the Platform and suggest Media or Creators on its Feed.
          </Typography.Paragraph>
          <Typography.Paragraph>This data will be kept as Confidential Information, hosted and protected in a secure manner.</Typography.Paragraph>
          <Typography.Paragraph>Article 15. Assistance and support</Typography.Paragraph>
          <Typography.Paragraph>
            For any questions relating to the use of the Platform, the User is invited, first of all, to consult the Support section of the Platform
            available at: https://support.${APP_DOMAIN}.
          </Typography.Paragraph>
          <Typography.Paragraph>
            In any case, any question or complaint concerning the use or operation of the Platform may be formulated in the following ways:
          </Typography.Paragraph>
          <Typography.Paragraph>– By email to the following address: support@${APP_DOMAIN}</Typography.Paragraph>
          <Typography.Paragraph>Article 16. Validity of the T&amp;Cs</Typography.Paragraph>
          <Typography.Paragraph>
            If any of the provisions of these T&amp;Cs are declared, in whole or in part, null, illegal or unenforceable under a legislative or
            regulatory provision in force and/or a court decision having the authority of res judicata, it will be deemed unwritten but will in no way
            affect the validity, legality or applicability of the other clauses that will remain fully applicable.
          </Typography.Paragraph>
          <Typography.Paragraph>
            In such a case, however, and in order to prevent the T&amp;Cs from surviving in a truncated and/or incoherent form, the Operator
            undertakes to incorporate into the T&amp;Cs a new provision aimed at reproducing the economy in the initial clause, in compliance with the
            applicable legal and regulatory provisions and as soon as possible.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Such a modification or decision does not in any way authorize Users to disregard these General Terms and Conditions of Use.
          </Typography.Paragraph>
          <Typography.Paragraph>Article 17. Modification of the T&amp;Cs</Typography.Paragraph>
          <Typography.Paragraph>These T&amp;Cs apply to any User browsing the Platform.</Typography.Paragraph>
          <Typography.Paragraph>
            The T&amp;Cs may be modified and updated by the Operator at any time, in particular to adapt to legislative or regulatory developments.
          </Typography.Paragraph>
          <Typography.Paragraph>Users will be notified of any changes to these General Terms and Conditions of Use.</Typography.Paragraph>
          <Typography.Paragraph>The applicable T&amp;Cs are those in force at the time of navigation on the Platform.</Typography.Paragraph>
          <Typography.Paragraph>Article 18. General Provisions</Typography.Paragraph>
          <Typography.Paragraph>
            The fact that one of the Parties has not required the application of any clause of these T&amp;Cs, whether permanently or temporarily, can
            in no way be considered a waiver of the said clause.
          </Typography.Paragraph>
          <Typography.Paragraph>
            In the event of difficulty in interpretation between any of the titles appearing at the head of the clauses, and any of them, the titles
            will be declared non-existent.
          </Typography.Paragraph>
          <Typography.Paragraph>Article 19. Jurisdiction and applicable law</Typography.Paragraph>
          <Typography.Paragraph>
            THESE T&amp;Cs AND THE RELATIONS BETWEEN THE USER AND Twizz ARE GOVERNED BY BELGIAN LAW. IN THE EVENT OF A DISPUTE, ONLY THE BELGIAN
            COURTS WILL HAVE JURISDICTION.
          </Typography.Paragraph>
          <Typography.Paragraph>19.1. Stipulations applicable to Users with consumer status</Typography.Paragraph>
          <Typography.Paragraph>
            In accordance with Articles L611-1 et seq. and R612-1 et seq. of the Consumer Code, it is provided that for any dispute of a contractual
            nature concerning the execution of the sales contract and/or the provision of services that could not be resolved in the context of a
            complaint previously filed with Twizz, the Consumer may use mediation free of charge.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The Party wishing to implement the mediation process must first inform the other party by registered letter with acknowledgment of receipt
            indicating the elements of the conflict. As mediation is not mandatory, the User or Twizz may withdraw from the process at any time.
          </Typography.Paragraph>
          <Typography.Paragraph>
            He will contact the National Association of Ombudsmen (ANM) either:
            <br />● By mail, by writing to 62 rue Tiquetonne 75002 PARIS
            <br />● By e-mail by filling out the online referral form at www.anm-conso.com
          </Typography.Paragraph>
          <Typography.Paragraph>
            In any case, the User is informed that the use of a mediator, or any form of attempt at an amicable resolution of a possible dispute is
            not mandatory, that he may end it at any time, and that this does not deprive him of the right to bring legal action.
          </Typography.Paragraph>
          <Typography.Paragraph>
            IN THE EVENT THAT MEDIATION FAILS OR IS NOT CONSIDERED, THE DISPUTE THAT MAY HAVE GIVEN RISE TO MEDIATION WILL BE ENTRUSTED TO THE
            COMPETENT COURT DESIGNATED ABOVE.
          </Typography.Paragraph>
          <Typography.Paragraph>19.2. Stipulations applicable to Users with professional status</Typography.Paragraph>
          <Typography.Paragraph>
            However, prior to any recourse to the arbitral or state judge, the User is invited to contact, first of all, Twizz’s Customer Service,
            available at this address: support@${APP_DOMAIN}.
          </Typography.Paragraph>
          <Typography.Paragraph>
            If no agreement is reached, then an optional mediation procedure will be proposed, conducted in a spirit of loyalty and good faith with a
            view to reaching an amicable agreement upon the occurrence of any conflict hereunder, including its validity
          </Typography.Paragraph>
          <Typography.Paragraph>
            The Party wishing to implement the mediation process must first inform the other party by registered letter with acknowledgment of receipt
            indicating the elements of the conflict.
          </Typography.Paragraph>
          <Typography.Paragraph>As mediation is not mandatory, Twizz or the User may withdraw from the process at any time.</Typography.Paragraph>
          <Typography.Paragraph>
            In the event that mediation fails or is not considered, the dispute that may have given rise to mediation will be entrusted to the
            competent court designated above. &nbsp;Annex 1 – Legal guarantee of conformity for Users with consumer status
          </Typography.Paragraph>
          <Typography.Paragraph>
            Apart from the commercial guarantees that Twizz may offer for certain Services, the User benefits from legal guarantees as defined by
            Articles L.224-25-12 et seq. of the Consumer Code and detailed below.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The User is informed of the application of Article L.224-25-12 of the Consumer Code, which provides for the delivery of a good in
            accordance with the contract as well as the criteria set out in Article L. 224-14. The User may report any defects of conformity existing
            at the time of the provision of the Service within the meaning of Article L.225-25-10 of the Consumer Code, which appear during the period
            of provision of the SERVICE as provided for in the General Conditions of Use.
          </Typography.Paragraph>
          <Typography.Paragraph>
            This warranty also applies to lack of conformity resulting from the incorrect integration of the SERVICE into the Customer’s digital
            environment:
          </Typography.Paragraph>
          <Typography.Paragraph>
            – When it was carried out by Twizz or under his responsibility; or
            <br />– When it has been carried out by the User, provided that it results from deficiencies in Twizz’s instructions.
          </Typography.Paragraph>
          <Typography.Paragraph>
            In this regard, pursuant to Articles L.224-25-13 and L.224-25-14 of the Consumer Code, the Service is compliant provided that:
          </Typography.Paragraph>
          <Typography.Paragraph>
            1° It corresponds to its description, type, quantity and quality, […] concerning any characteristic provided for in the Contract (Article
            5) or that the User may legitimately expect for Services of the same type, having regard to the nature of these Services as well as the
            public declarations made by Twizz or any person upstream in the chain of transactions, including in advertising or on labelling; 2° It is
            suitable for any special purpose sought by the User, brought to the attention of Twizz at the latest at the time of the conclusion of the
            CONTRACT and accepted by the latter; 3° It is issued with all the accessories […] to be provided in accordance with the Contract or which
            the User can legitimately expect; 4° It is updated in accordance with the Contract and what the User can legitimately expect; 5° It is
            suitable for the use usually expected of a Service of the same type […]; 6° It has the qualities that Twizz presented to the User in the
            form of a trial or preview version before the conclusion of the Contract; 7° It is provided according to the most recent version available
            at the time of the conclusion of the Contract, unless otherwise agreed by the Parties; 8° It is provided without interruption throughout
            this period.
          </Typography.Paragraph>
          <Typography.Paragraph>
            However, Twizz is not bound by any public statements mentioned in 1° above if he demonstrates: (a) that he did not know them and was not
            legitimately able to know them; (b) that at the time of the conclusion of the contract, the public statements had been rectified under
            conditions comparable to the initial declarations; or (b) that the public statements could not have had any influence on the purchase
            decision.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The User may not contest conformity by invoking a defect concerning one or more particular characteristics of the Service of which he was
            specifically informed that they deviated from the conformity criteria, a deviation to which he expressly and separately consented at the
            time of the conclusion of the Contract. As such, the Service may in particular experience interruptions during the duration of the
            provision of the Service in accordance with the General Conditions of Use.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Throughout the contractual period of provision of the Service, proof of compliance of the Service is the responsibility of Twizz.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Twizz is not responsible for any lack of conformity directly attributable to the incompatibility between the Service and the Customer’s
            digital environment and that the User had been previously informed by Twizz of the technical compatibility requirements. As such, the User
            must cooperate with Twizz, to the extent reasonably possible, in order to establish whether or not the lack of conformity is caused by the
            incompatibility in question. In the absence of cooperation, the User will bear the burden of demonstrating the non-conformity of the
            Service.
          </Typography.Paragraph>
          <Typography.Paragraph>
            In the event of lack of conformity, the User is entitled to the conformity of the Service or, failing that, to the reduction of the price
            or the resolution of the price in accordance with Articles L. 224-25-17 et seq. of the Consumer Code. The User also has the right to
            suspend payment until Twizz complies with its guarantee obligations under the conditions of Articles 1219 and 1220 of the Civil Code.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Compliance takes place free of charge, without undue delay following the Customer’s request and without major inconvenience for him, given
            the nature and intended use of the Service. He is not required to pay for the use of the Service during the contractual period during
            which the Service was not compliant.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Twizz may refuse compliance if it is impossible or incurs disproportionate costs in particular:
            <br />– Of the value that the Service would have in the absence of a lack of conformity ;<br />– The importance of the lack of conformity.
          </Typography.Paragraph>
          <Typography.Paragraph>
            This refusal is the subject of a reasoned decision in writing or on any durable medium addressed to the User. When these conditions are
            not respected, the User may, after formal notice, continue the forced execution in kind of the compliance.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The User has the right to a reduction in the price or to the termination of the Contract (unless the lack of conformity is minor) in the
            cases and in accordance with the procedures provided for in Article L.224-25-20 of the Consumer Code, i.e., in particular, in the event of
            refusal of compliance or Twizz’s failure to comply, in accordance with the above-mentioned article.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The User is not required to request prior compliance when the lack of conformity is so serious that it justifies that the price reduction
            or the termination of the Contract is immediate.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The User informs Twizz of his decision to obtain a price reduction or the resolution of the Contract.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The price reduction is proportional to the difference between the value of the Service provided and the value of the Service without
            defect.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Twizz reimburses the User and returns to him any other benefit received under the Contract as soon as possible and at the latest within
            fourteen (14) days of the notification of the decision to terminate the Contract or obtain the price reduction. Unless expressly agreed by
            the Customer and at no additional cost, the refund will take place according to the same means of payment as that used for the purchase.
          </Typography.Paragraph>
          <Typography.Paragraph>
            In the event of termination of the Contract, the User refrains from using the Service or making it accessible to third parties.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Twizz returns to the User, free of charge and within a reasonable time, in a commonly used and machine-readable format, any content
            provided or created by the User during his use of the Service (other than personal data), unless it: 1° is of no use outside the context
            of use of the Service; 2° relates only to the Customer’s activity when using the Service; or 3° if this content has been aggregated by the
            Twizz with other data and can only be disaggregated or can only be disaggregated with disproportionate efforts.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Le Twizz undertakes to use the content provided or created by the User (other than personal data) only if it has been generated jointly
            with other customers and if other customers can continue to use it.
          </Typography.Paragraph>
          <Typography.Paragraph>The provisions of this article are without prejudice to the award of damages.</Typography.Paragraph>
          <Typography.Paragraph>Annex 2 – Rights and obligations in civil and tax matters of Users</Typography.Paragraph>
          <Typography.Paragraph>
            As an online platform, Twizz wishes to optimally support all Users in their use of the Platform.
          </Typography.Paragraph>
          <Typography.Paragraph>
            As such, Twizz wishes to inform any Creator who generates income on Twizz of its civil and tax obligations, related to the generation of
            income through the Platform.
          </Typography.Paragraph>
          <Typography.Paragraph>
            In this case, all the useful information in this area is grouped in educational sheets recalling the rules applicable to the declaration
            of income and the payment of social contributions.
          </Typography.Paragraph>
          <Typography.Paragraph>
            This information can be consulted at the following addresses :<br />● On www.impots.gouv.fr, concerning tax obligations, link below:
            <br />o Https://www.impots.gouv.fr/portail/node/10841
            <br />● On www.urssaf.fr, concerning social obligations, link below O
            https://www.urssaf.fr/portail/home/espaces-dedies/activites-relevant-de-leconomie.html
            <br />
            The following information sheets, intended for Creators and Ambassadors, are also available in French at the following addresses :<br />●
            https://www.impots.gouv.fr/portail/files/media/1_metier/1_particulier/EV/1_declarer/141_autres_revenus/eco-collabo-fiscal-service.pdf
          </Typography.Paragraph>
          <Typography.Paragraph>
            With regard to the payment of VAT, Creators and Ambassadors are invited to consult the information provided by the French administration:
            https://www.impots.gouv.fr/professionnel/je-recherche-les-regles-de-territorialite-tva-page-en-cours-de-creation.
          </Typography.Paragraph>
          <Typography.Paragraph>
            In terms of social protection, this income must be able to give rise to health insurance or retirement rights. The same applies to tax
            matters: the income generated must be subject to tax.
          </Typography.Paragraph>
          <Typography.Paragraph>
            We remind you that the above explanations are given as an indication and do not replace the reading of legislative texts, administrative
            comments and French case law. We also insist that the rules set out above are likely to change (in particular the different thresholds
            that are reassessed each year) and that each User of the Platform is solely responsible for his legal and in particular tax and social
            obligations.
          </Typography.Paragraph>
          <Typography.Paragraph>
            In addition, the tax administration and social security funds are able to complete this information and answer any questions.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Twizz therefore recommends that any User contact his tax center, social security fund or a specialized advisor in case of doubt.
          </Typography.Paragraph>
        </Row>
      </Layout.Content>
    </Layout>
  );
};

export default GeneralCondtionOfUse;
